
window.addEventListener('load', function() {
    console.log('All assets are loaded')
  const currentPath = window.location.href;
    const menuLinks = document.querySelectorAll('.Meteor-Navigation__Link__desktop');

    menuLinks.forEach(link => {
      const href = new URL(link.href).href;
      if (currentPath === href ) {
        link.classList.add('meteor-active');
      }
    });
})